import serverProps from '../utils/serverProps'
import { ActionTypes as types } from '../constants'

function getInitialState(props) {
  const {
    visaPlusData: {
      eligibility: {
        evaluationStatus = '',
        ineligibleReasons = [],
        suggestedActions = [],
      } = {},
      profile: { profileId = '', profileStatus = '' } = {},
      tokenId = '',
      senderInfo: {
        balances = [],
        senderSuggestedActions = [],
        paymentCapabilities: {
          maximumTransactionAmount = '',
          supportedSenderCurrencies = [],
        } = {},
      } = {},
      receiverInfo: { id = '', givenName = '', surname = '' } = {},
      localizedError = {},
    } = {},
  } = props

  const initialState = {
    visaPlusData: {
      eligibility: {
        evaluationStatus,
        ineligibleReasons,
        suggestedActions,
      },
      profile: {
        profileId,
        profileStatus,
      },
      tokenId,
      senderInfo: {
        balances,
        senderSuggestedActions,
        paymentCapabilities: {
          maximumTransactionAmount,
          supportedSenderCurrencies,
        },
      },
      receiverInfo: {
        id,
        givenName,
        surname,
      },
      localizedError,
    },
  }
  return initialState
}

export default (state = getInitialState(serverProps), action) => {
  switch (action.type) {
    case types.VISAPLUS.TOGGLE_ACCOUNT_ACTIVATION_STATUS:
      return {
        ...state,
        visaPlusData: {
          ...state.visaPlusData,
          isAccountActivated: action.data.isAccountActivated,
        },
      }
    case types.VISAPLUS.CREATE_PAYNAME:
      return {
        ...state,
        visaPlusData: {
          ...state.visaPlusData,
          profile: {
            ...state.visaPlusData.profile,
            error: action.data.error || '',
            profileId: action.data.profileId || '',
          },
          payname: action.data.payname,
        },
      }
    case types.VISAPLUS.VERIFY_RECEIVER_PAYNAME:
      const { receiverInfo, senderInfo, tokenId, localizedError } = action.data
      return {
        ...state,
        visaPlusData: {
          ...state.visaPlusData,
          tokenId,
          localizedError,
          receiverInfo,
          senderInfo,
        },
      }
    default:
      return state
  }
}
